// components/Posts/PostActions.jsx
// 좋아요 · 북마크 · 신고  ─ 툴바 스타일

import { useState } from 'react';
import {
  Stack, IconButton, Tooltip, Badge
} from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import FlagIcon from '@mui/icons-material/Flag';

import { toggleLike, toggleBookmark } from '../../api/posts';

const PostActions = ({
  postId,
  likeStatus,
  setLikeStatus,
  isBookmarked,
  setIsBookmarked,
  onReport,
}) => {
  const [loading, setLoading] = useState(false);

  /* ── 핸들러 ─────────────────────────── */
  const handleToggleLike = () => {
    setLoading(true);
    toggleLike(postId)
      .then(res => setLikeStatus(res.data))      // { liked, like_count }
      .catch(() => alert('좋아요 처리에 실패했습니다.'))
      .finally(() => setLoading(false));
  };

  const handleToggleBookmark = () => {
    setLoading(true);
    toggleBookmark(postId)
      .then(res => setIsBookmarked(res.data.bookmarked))
      .catch(() => alert('북마크 처리에 실패했습니다.'))
      .finally(() => setLoading(false));
  };

  const handleReportClick = () => {
    onReport(postId, 'post');
  };

  /* ── 렌더 ───────────────────────────── */
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      flexWrap="wrap"
      sx={{ mt: 1 }}
    >
      {/* 좋아요 */}
      <Tooltip title={likeStatus.liked ? '좋아요 취소' : '좋아요'}>
        {/* Tooltip + disabled 조합을 위해 span 래퍼 */}
        <span>
          <IconButton
            color={likeStatus.liked ? 'secondary' : 'default'}
            onClick={handleToggleLike}
            disabled={loading}
            aria-label="toggle like"
          >
            <Badge
              badgeContent={likeStatus.like_count}
              color="secondary"
              max={999}
            >
              {likeStatus.liked ? <FavoriteIcon /> : <FavoriteBorderIcon />}
            </Badge>
          </IconButton>
        </span>
      </Tooltip>

      {/* 북마크 */}
      <Tooltip title={isBookmarked ? '북마크 삭제' : '북마크 추가'}>
        <span>
          <IconButton
            color={isBookmarked ? 'primary' : 'default'}
            onClick={handleToggleBookmark}
            disabled={loading}
            aria-label="toggle bookmark"
          >
            {isBookmarked ? <BookmarkIcon /> : <BookmarkBorderIcon />}
          </IconButton>
        </span>
      </Tooltip>

      {/* 신고 */}
      <Tooltip title="신고하기">
        <span>
          <IconButton
            color="error"
            onClick={handleReportClick}
            disabled={loading}
            aria-label="report post"
          >
            <FlagIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
};

/* 기본 props (미연결 테스트용) */
PostActions.defaultProps = {
  likeStatus: { liked: false, like_count: 0 },
  setLikeStatus: () => { },
  isBookmarked: false,
  setIsBookmarked: () => { },
  onReport: (id, type) => alert(`신고: ${type}, ID: ${id}`),
};

export default PostActions;
